/* Landing screen — hero search, hot-deals ticker + grid, feature strip,
 * About/Services/footer. Ported verbatim from templates/ELCAPP.html. */
import { useState, useEffect, C, Ic, F, AirportSearch } from './common.js';

const Landing = ({ setScreen, setFD, user }) => {
  const [form, setForm] = useState({ origin: '', dest: '', date: '' });
  const [hotDeals, setHotDeals] = useState([]);
  const [airports, setAirports] = useState([]);

  useEffect(() => {
    fetch('/api/elcapp/hot-deals')
      .then(r => r.json())
      .then(d => setHotDeals(d.deals || []))
      .catch(() => {});
  }, [user.loggedIn]);

  useEffect(() => {
    fetch('/api/elcapp/airports')
      .then(r => r.json())
      .then(d => setAirports(d.airports || []))
      .catch(() => {});
  }, []);

  const tickerDeals = hotDeals.length > 0 ? [...hotDeals, ...hotDeals, ...hotDeals] : [];

  return <div>
    <div className="gbg" style={{ position: 'relative', zIndex: 10, padding: '72px 40px 64px', background: `radial-gradient(ellipse 80% 70% at 50% 50%, rgba(37,99,235,0.10) 0%, transparent 70%), ${C.bg}` }}>
      <div style={{ maxWidth: 800, margin: '0 auto', animation: 'fadein .6s ease both', position:'relative', zIndex:2, display:'flex', flexDirection:'column', alignItems:'center', textAlign:'center' }}>
        <div className="badge b-bl" style={{ marginBottom: 18 }}><Ic.Plane sz={9} col="currentColor" r={-45} />Est. 1985 · IATA Certified · FMC Licensed</div>
        <h1 className="bc" style={{ fontSize: 78, fontWeight: 800, lineHeight: .92, letterSpacing: '-.01em', marginBottom: 18, background: 'linear-gradient(135deg,#0f172a 20%,#1d4ed8 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>EXPRESS LINE<br />AIR FREIGHT<br />MADE INSTANT</h1>
        <p style={{ fontSize: 17, color: C.textM, marginBottom: 40, maxWidth: 520, lineHeight: 1.65 }}>40 years of freight expertise, now online. Get competitive carrier rates from US to Asia in seconds — and book with confidence.</p>
        <div style={{ background: C.s1, border: `1px solid ${C.brd}`, borderRadius: 12, padding: '18px 20px', display: 'grid', gridTemplateColumns: '1fr 1fr 160px 140px', gap: 12, alignItems: 'end', width: '100%', maxWidth: 760 }}>
          <F label="Origin">
            <AirportSearch
              value={form.origin}
              onChange={(v) => setForm({ ...form, origin: v })}
              options={airports}
              placeholder="LAX, Los Angeles…"
              leadingIcon={<Ic.Pin sz={13} />}
            />
          </F>
          <F label="Destination">
            <AirportSearch
              value={form.dest}
              onChange={(v) => setForm({ ...form, dest: v })}
              options={airports}
              placeholder="PVG, Shanghai…"
              leadingIcon={<Ic.Pin sz={13} />}
            />
          </F>
          <F label="Ready Date"><input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></F>
          <div><button className="btn bg" style={{ width: '100%', fontSize: 15, padding: '11px' }} onClick={() => {setFD(form);setScreen('quote');}}>GET QUOTE</button></div>
        </div>
      </div>
    </div>

    {tickerDeals.length > 0 && <div style={{ background: C.s1, borderTop: `2px solid ${C.brd}`, borderBottom: `2px solid ${C.brd}`, padding: '16px 0', overflow: 'hidden' }}>
      <div style={{ display: 'flex', animation: 'ticker 30s linear infinite', whiteSpace: 'nowrap' }}>
        {tickerDeals.map((d, i) =>
        <span key={i} style={{ padding: '0 36px', color: C.textM, fontSize: 14, display: 'inline-flex', alignItems: 'center', gap: 10 }}>
            <span className="mono" style={{ color: C.goldL, fontWeight: 700, fontSize: 15 }}>{(d.origin||'').replace('US','').replace('CN','')}</span>
            <Ic.Plane sz={13} col={C.blueL} r={-45} />
            <span className="mono" style={{ color: C.goldL, fontWeight: 700, fontSize: 15 }}>{(d.dest||'').replace('US','').replace('CN','')}</span>
            {d.price_masked
              ? <span style={{ color: C.textD }}>LOGIN TO VIEW RATE</span>
              : <span style={{ color: C.green, fontWeight: 700 }}>FROM ${d.per_kg}/kg</span>}
            <span style={{ color: C.textD }}>·</span><span style={{ color: C.textD }}>{d.product}</span>
            <span style={{ color: 'rgba(0,0,0,0.2)', fontWeight: 300, fontSize: 18 }}>|</span>
          </span>
        )}
      </div>
    </div>}

    <div style={{ padding: '52px 40px', maxWidth: 1160, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: 28 }}>
        <div><h2 className="bc" style={{ fontSize: 34, fontWeight: 700, letterSpacing: '.02em' }}>TODAY'S HOT DEALS</h2>
        <p style={{ color: C.textM, fontSize: 13, marginTop: 4 }}>Real-time competitive rates · Updated daily by our team</p></div>
        <button className="btn bo" style={{ fontSize: 12 }} onClick={() => setScreen('quote')}>View All Routes →</button>
      </div>
      {hotDeals.length === 0
        ? <div style={{ textAlign: 'center', padding: '40px 20px', color: C.textD, background: C.s1, borderRadius: 12, marginBottom: 52 }}>
            <div style={{ fontSize: 28, marginBottom: 10 }}>✈️</div>
            <div style={{ fontSize: 14 }}>No hot deals available right now. Check back soon.</div>
          </div>
        : <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 52 }}>
          {hotDeals.map((d, i) =>
          <div key={d.id || i} className="card" style={{ padding: 24, cursor: 'pointer', transition: 'border-color .2s,transform .2s' }}
          onMouseEnter={(e) => {e.currentTarget.style.borderColor = '#2563eb';e.currentTarget.style.transform = 'translateY(-3px)';}}
          onMouseLeave={(e) => {e.currentTarget.style.borderColor = 'rgba(0,0,0,0.08)';e.currentTarget.style.transform = 'none';}}
          onClick={() => setScreen('quote')}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <span className="bc mono" style={{ fontSize: 22, fontWeight: 800 }}>{(d.origin||'').slice(-3)}</span>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    <Ic.Plane sz={13} col={C.blueL} r={-45} />
                    <div style={{ width: 36, height: 1, background: `linear-gradient(90deg,${C.blueL},${C.goldL})`, opacity: .5 }} />
                  </div>
                  <span className="bc mono" style={{ fontSize: 22, fontWeight: 800 }}>{(d.dest||'').slice(-3)}</span>
                </div>
                <div className="badge b-go">HOT</div>
              </div>
              <div style={{ fontSize: 13, color: C.textM, marginBottom: 3 }}>{d.product}</div>
              <div style={{ fontSize: 11, color: C.textD, marginBottom: 16 }}>{d.commodity}</div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontSize: 10, color: C.textD, textTransform: 'uppercase', letterSpacing: '.1em' }}>From</div>
                  {d.price_masked
                    ? <div>
                        <div className="bc" style={{ fontSize: 22, fontWeight: 800, color: C.textD }}>— — —</div>
                        <div style={{ fontSize: 11, color: C.textD, marginTop: 2 }}>Login to view rate</div>
                      </div>
                    : <div className="bc" style={{ fontSize: 28, fontWeight: 800, color: C.green }}>${d.per_kg}<span style={{ fontSize: 13, color: C.textM, fontWeight: 400 }}>/kg</span></div>
                  }
                </div>
                <div>
                  <div style={{ fontSize: 10, color: C.textD, marginBottom: 3, textAlign: 'right' }}>Transit</div>
                  <div style={{ fontSize: 13, color: C.textM, display: 'flex', alignItems: 'center', gap: 4 }}><Ic.Clock sz={12} />{d.transit}</div>
                </div>
              </div>
              {d.price_masked
                ? <button className="btn bo" style={{ width: '100%', marginTop: 14, fontSize: 12, padding: '8px' }} onClick={(e) => {e.stopPropagation();setScreen('login');}}>LOGIN TO VIEW</button>
                : <button className="btn bb" style={{ width: '100%', marginTop: 14, fontSize: 12, padding: '8px' }} onClick={(e) => {e.stopPropagation();setScreen('quote');}}>GET QUOTE</button>
              }
            </div>
          )}
        </div>
      }
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', borderTop: `1px solid ${C.brd}` }}>
        {[{ t: 'Instant Quotes', d: 'AI pricing engine delivers results in seconds', col: C.blue }, { t: '50+ Carriers', d: 'Cathay, ANA, SIA Cargo, Air China & more', col: C.goldL }, { t: 'Live Tracking', d: 'Real-time visibility from pickup to delivery', col: C.green }, { t: 'Guaranteed Space', d: 'Confirmed bookings with space guarantee', col: '#a78bfa' }].map((f, i) =>
        <div key={i} style={{ padding: '26px 24px', borderRight: i < 3 ? `1px solid ${C.brd}` : 'none', borderTop: `3px solid ${f.col}` }}>
            <div className="bc" style={{ fontSize: 17, fontWeight: 700, marginBottom: 8, marginTop: 4 }}>{f.t}</div>
            <div style={{ fontSize: 13, color: C.textM, lineHeight: 1.6 }}>{f.d}</div>
          </div>
        )}
      </div>
    </div>

    {/* ── ABOUT ELC ── */}
    <div style={{ borderTop: `1px solid ${C.brd}`, background: C.s1 }}>
      <div style={{ maxWidth: 1160, margin: '0 auto', padding: '72px 40px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'center', marginBottom: 64 }}>
          <div>
            <div className="badge b-bl" style={{ marginBottom: 16 }}>About Us</div>
            <h2 className="bc" style={{ fontSize: 52, fontWeight: 800, lineHeight: .95, letterSpacing: '-.01em', marginBottom: 20, background: 'linear-gradient(135deg,#0f172a 30%,#1d4ed8 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              EXCELLENT<br />SERVICE.<br />COMPETITIVE<br />RATES.
            </h2>
            <p style={{ fontSize: 15, color: C.textM, lineHeight: 1.75, marginBottom: 24 }}>
              Conceptualized and established in 1985, Express Line Corporation (ELC) is a privately owned freight forwarder that has successfully lived up to its ideals for over three decades.
            </p>
            <p style={{ fontSize: 14, color: C.textD, lineHeight: 1.75, fontStyle: 'italic', borderLeft: `3px solid ${C.blue}`, paddingLeft: 16 }}>
              "Only the best" has been the guiding principle of each and every member in the ELC family.
            </p>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {[
            { val: '40+', label: 'Years of Experience', col: C.blue },
            { val: 'IATA', label: 'Certified Member', col: C.goldL },
            { val: 'FMC', label: 'Federal Maritime Commission', col: C.green },
            { val: 'US→Asia', label: 'Primary Trade Lane', col: '#a78bfa' }].
            map((s, i) =>
            <div key={i} style={{ background: C.s2, border: `1px solid ${C.brd}`, borderRadius: 12, padding: '24px 20px', borderTop: `3px solid ${s.col}` }}>
                <div className="bc" style={{ fontSize: 36, fontWeight: 800, color: s.col, lineHeight: 1, marginBottom: 6 }}>{s.val}</div>
                <div style={{ fontSize: 12, color: C.textM, lineHeight: 1.4 }}>{s.label}</div>
              </div>
            )}
          </div>
        </div>

        <div style={{ marginBottom: 56 }}>
          <h3 className="bc" style={{ fontSize: 26, fontWeight: 700, marginBottom: 24, letterSpacing: '.02em' }}>OUR SERVICES</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16 }}>
            {[
            { title: 'Air Freight', icon: '✈️', desc: 'With deep expertise in air logistics and longstanding carrier relationships, ELC grants access to aircraft capacity worldwide — achieving the balance of speed and value your business demands.' },
            { title: 'Ocean Freight', icon: '🚢', desc: 'Reliable, flexible, and seamless ocean logistics solutions. From full containers to loose freight and buyer\'s consolidation, we provide cost-effective cargo transportation for your supply chain.' },
            { title: 'Customs Brokerage', icon: '📋', desc: 'Our experienced customs team handles all compliance, documentation and clearance requirements, ensuring your cargo moves smoothly across international borders without delays.' },
            { title: 'Trucking & Pickup', icon: '🚛', desc: 'Door-to-door trucking services from your facility directly to the cargo terminal. Flexible pickup scheduling with real-time updates — all coordinated through a single point of contact.' },
            { title: 'Warehousing', icon: '🏭', desc: 'Short and long-term warehousing solutions including repack, palletizing, labeling and inventory management — available at our facilities near major US gateway airports.' },
            { title: 'Cargo Insurance', icon: '🛡️', desc: 'Protect your shipments with comprehensive cargo insurance coverage. We work with leading underwriters to offer competitive rates tailored to your commodity and trade lane.' }].
            map((s, i) =>
            <div key={i} style={{ background: s.highlight ? `linear-gradient(135deg, rgba(37,99,235,0.08), rgba(37,99,235,0.03))` : 'rgba(0,0,0,0.02)', border: `1px solid ${s.highlight ? 'rgba(37,99,235,0.25)' : C.brd}`, borderRadius: 12, padding: '24px 22px', transition: 'border-color .2s,transform .2s', cursor: 'default' }}
            onMouseEnter={(e) => {e.currentTarget.style.borderColor = '#3b82f6';e.currentTarget.style.transform = 'translateY(-2px)';}}
            onMouseLeave={(e) => {e.currentTarget.style.borderColor = s.highlight ? 'rgba(37,99,235,0.3)' : C.brd;e.currentTarget.style.transform = 'none';}}>
                <div style={{ fontSize: 26, marginBottom: 12 }}>{s.icon}</div>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 8, color: s.highlight ? '#fff' : C.text }}>{s.title}</div>
                <div style={{ fontSize: 12, color: C.textM, lineHeight: 1.7 }}>{s.desc}</div>
              </div>
            )}
          </div>
        </div>

        <div style={{ background: `linear-gradient(135deg, rgba(37,99,235,0.12), rgba(37,99,235,0.04))`, border: `1px solid rgba(37,99,235,0.2)`, borderRadius: 16, padding: '40px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 className="bc" style={{ fontSize: 28, fontWeight: 700, marginBottom: 8 }}>READY TO SHIP WITH ELC?</h3>
            <p style={{ fontSize: 14, color: C.textM, maxWidth: 480 }}>
              The global shipping community has continuously entrusted ELC with its logistics needs. Join thousands of satisfied clients who choose us for competitive rates and unparalleled service.
            </p>
          </div>
          <div style={{ display: 'flex', gap: 12, flexShrink: 0 }}>
            <button className="btn bo" style={{ fontSize: 13, padding: '11px 24px' }}>Contact Us</button>
            <button className="btn bb" style={{ fontSize: 14, padding: '12px 32px' }} onClick={() => setScreen('quote')}>GET QUOTE NOW</button>
          </div>
        </div>

        <div style={{ marginTop: 40, paddingTop: 24, borderTop: `1px solid ${C.brd}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
          <div style={{ display: 'flex', gap: 32 }}>
            {[['📍', '901 W. Arbor Vitae St., Inglewood, CA 90301'], ['📞', '310.645.1355'], ['🌐', 'expresslinecorp.com']].map(([icon, val]) =>
            <div key={val} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: C.textM }}><span>{icon}</span>{val}</div>
            )}
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            {['IATA Certified', 'FMC Licensed', 'Dept. of Commerce Accredited'].map((b) =>
            <span key={b} className="badge" style={{ background: 'rgba(0,0,0,0.04)', color: C.textD, border: `1px solid ${C.brd}` }}>{b}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>;
};

export { Landing };
